import React, { Component } from "react";
import { apiReadOneAsset } from "../../../../utils/apis.js"
import Dialog from "../../../dialogs/dialog.js";
import { sequencesGetEmotionsList } from "../../../../utils/sequences.js";
import { GlobalContext } from "../../../../utils/globalprovider.js";
import { directDownloadJson } from "../utils.js";
import { getlocalhostDatas } from "../../../../utils/apis.js";
import { V2_ConvertSecondToTimeCodeStringFromAsset } from "../../../../utils/timecodev2.js";

import ShowSequences from "./showsequences/showsequences.js";
import imgia from "./assets/ia.png"
import imghuman from "./assets/human.png"


import "./assetsmanager.css"



class DisplaySequences extends Dialog
{
  static contextType = GlobalContext;
  constructor(props) 
  {
    super(props);

    const title = {
        en:"Sequences", 
        fr:"Séquences",
      };
    this.state.title = title;

    this.state.buttons = 
    [
      {type:"back", disabled:false},
      
    ]

    this.handleButton =  this.handleButton.bind(this);

    this.onQuit = this.onQuit.bind(this)
    


    this.state.timecodeAsset = this.props.asset;

    this.state.emotionslist = [];
    this.state.conceptSetCorrected ={};
    this.state.assetread = false;
    this.state.topicsread = false;

    this.apicallback = this.apicallback.bind(this);
    this.OtherFilesdownloadDone = this.OtherFilesdownloadDone.bind(this);
    this.getTimeCodeString = this.getTimeCodeString.bind(this);
    
  }


componentDidMount()
{
    super.componentDidMount()
    var datas = {asid: this.props.asset.asid};
    
    apiReadOneAsset (datas, this.apicallback);


}

componentWillUnmount()
{
}

componentDidUpdate()
{
}

getTimeCodeString(tc)
{
    return V2_ConvertSecondToTimeCodeStringFromAsset(tc, this.state.asset,false)
}

 apicallback(datas)
 {
    if (datas.ret)
    {
         var alldatas = JSON.parse(datas.asdatas);
        delete datas.asdatas;
        delete datas.ret;

          this.setState ({ sequences: alldatas.sequences,
                assetread: true,
                asset: datas,
                emotionslist: sequencesGetEmotionsList(this.context.language),
          })
          directDownloadJson (getlocalhostDatas() + "fr/topics_fr.json",this.OtherFilesdownloadDone,"ipc") 
        console.log("sequences = ", alldatas.sequences);
        console.log("asset", datas)
    }
 }

 OtherFilesdownloadDone(blob, infos, file)
    {
        var conceptSetCorrected = blob;
        // on nettoie si besoin
        Object.values(conceptSetCorrected).forEach (elem =>{
        if ("iptc_code" in elem)
            elem.iptc_code = elem.iptc_code.replace(/^medtop:/, "");
        if ("children" in elem)
        {
            elem.children.forEach(child =>{
                if (("iptc_code" in child) && (child.iptc_code))
                child.iptc_code = child.iptc_code.replace(/^medtop:/, "");

            })
        }
        })
        this.setState({topicsread:  true,conceptSetCorrected:conceptSetCorrected});
        console.log(conceptSetCorrected)
       
    }
 onQuit()
  {
    this.props.onButton("back");    
  }


  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)
    if (buttonkey === "back")
        this.props.onButton("back");
    
  }

  
  render()
  {
    var maxwidth =  (window.innerWidth * 60)/100;
    if (maxwidth > 600) maxwidth = 600;

    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 500) maxheight = 500;


    var retour = [<></>];
    if (this.props.display)
    {

        var body = (<></>)
        if (this.state.assetread && this.state.topicsread)
            body = (<>


                <ShowSequences
                    sequences={this.state.sequences}
                    imgHuman={imghuman}
                    imgIA={imgia}
                    emotionsList={this.state.emotionslist}
                    iptccodes={this.state.conceptSetCorrected}
                    width={maxwidth}
                    height={maxheight}
                    formatTimeCodeFunction={this.getTimeCodeString}
                    language = {this.context.language}
                />

            </>)
        retour =
        (
          <div style = {{width:maxwidth, height: maxheight}}>
            {body}

          </div>
        )
      }
    return super.render(retour);
  }


}


export default DisplaySequences;